import Button from "../../../../../shared/components/Button";
import SecondaryIcon from "../../../../../shared/components/SecondaryIcon";
import Icons from "../../../../../shared/constants/icon.constant";
import CreditCard from "./CreditCard";

interface BankingOrderCreditCardProps {
  cardCharge?: string;
  deliveryCharge?: string;
}

export default function BankingOrderCreditCard({
  cardCharge,
  deliveryCharge,
}: Readonly<BankingOrderCreditCardProps>) {
  return (
    <div className="flex flex-col gap-6">
      <CreditCard name="Zakib Al Hareeray" cardNumber="1234 5678 9012 3456" />
      <div className="flex gap-4">
        <div className="bg-secondary rounded-2xl flex-1 p-4 flex flex-col items-center gap-2">
          <SecondaryIcon icon={Icons.Earth({ width: 40, height: 40 })} />
          <div className="text-xs text-label-dark">Availability</div>
        </div>
        <div className="bg-secondary rounded-2xl flex-1 p-4 flex flex-col items-center">
          <SecondaryIcon icon={Icons.BalanceLimit({ width: 40, height: 40 })} />
          <div className="text-xs text-label-dark">Limits</div>
        </div>
        <div className="bg-secondary rounded-2xl flex-1 p-4 flex flex-col items-center">
          <SecondaryIcon icon={Icons.Info({ width: 40, height: 40 })} />
          <div className="text-xs text-label-dark">Learn More</div>
        </div>
      </div>
      <div className="border border-white/10 rounded-3xl flex">
        {cardCharge && (
          <div className="flex flex-col flex-1 items-center p-4">
            <div className="text-label-dark text-sm">Card Charge</div>
            <div className="text-xl">{cardCharge}</div>
          </div>
        )}
        {deliveryCharge && cardCharge && (
          <div className="border-white/10 border-r" />
        )}
        {deliveryCharge && (
          <div className="flex flex-col flex-1 items-center p-4">
            <div className="text-label-dark text-sm">Delivery Charge</div>
            <div className="text-xl">{deliveryCharge}</div>
          </div>
        )}
      </div>
      <Button>Order the Card</Button>
    </div>
  );
}
